import React from 'react';
import { CtaButton } from './CtaButton';
type Props = {
  headline: string;
  label: string;
  variant?: 'navy' | 'gold';
  note?: string;
};

/** Transformational CTA block placed at the end of each section. */
export function SectionCta({
  headline,
  label,
  variant = 'navy',
  note = 'Instant digital access · One-time payment of $27 USD'
}: Props) {
  const isGold = variant === 'gold';
  return <div className={`mx-auto mt-10 w-full max-w-xl rounded-2xl border px-5 py-6 sm:px-8 sm:py-7 ${isGold ? 'border-gold/40 bg-white/5' : 'border-navy/10 bg-white'}`} data-id="element-282" data-mp="38n3vujkb0g0y">
      <p className={`mb-5 text-center font-serif text-[19px] font-bold leading-snug sm:text-2xl ${isGold ? 'text-cream' : 'text-navy'}`} data-id="element-283" data-mp="2zn79wppatv9l">
        {headline}
      </p>
      <CtaButton label={label} variant={variant} note={note} data-id="element-284" data-mp="2po9fx793t9j7" />
    </div>;
}